import { connect } from "react-redux";
import { InputAdornment, Stack, TextField } from "@mui/material";
import { FormText, IconButton } from "@itk/mui-components";
import { SearchProps } from "./search-types";
import { userManagementActions } from "../../user-management-store";
import { DekoxIcon } from "src/components/deko-x-icons";
import { FormContactPersonPermissionKindAutocomplete } from "src/components";
import { genericTranslationsK, useGenericTranslationsT } from "src/translation-hooks/generic-translations";
import { useInformationPageUsersSectionT } from "src/translation-hooks/information-page-users-section";

const ownActions = { setListShouldReload: userManagementActions.setListShouldReload };

type Props = typeof ownActions & SearchProps;
const SearchBase = (props: Props) => {
  const { formValues, setListShouldReload } = props;

  const informationPageUsersSectionT = useInformationPageUsersSectionT();
  const genericTranslationsT = useGenericTranslationsT();

  const { formController, formState } = formValues;

  return (
    <Stack gap={1} direction="row">
      <FormText
        width="100%"
        formFieldController={formController.wildcardSearch}
        formFieldState={formState.wildcardSearch}
        t={genericTranslationsT}
        field="dynamicValue"
        placeholder={informationPageUsersSectionT.nameEmail}
        k={genericTranslationsK}
        autoFocus
        sx={{
          width: 300,
          "& .MuiInputBase-root .MuiInputBase-input": {
            height: 15
          }
        }}
        slotProps={{
          input: {
            startAdornment: (
              <InputAdornment position="start">
                <DekoxIcon icon="search" color="primary" />
              </InputAdornment>
            )
          }
        }}
        autoComplete="off"
      />
      <FormContactPersonPermissionKindAutocomplete
        formFieldController={formController.permission}
        formFieldState={formState.permission}
        t={genericTranslationsT}
        k={genericTranslationsK}
        field="dynamicValue"
        disableClearable={false}
        renderInput={params => (
          <TextField {...params} size="small" placeholder={informationPageUsersSectionT.access} variant="outlined" sx={{ ".MuiOutlinedInput-root.MuiInputBase-sizeSmall": { paddingY: 1.2 } }} />
        )}
        sx={{
          "& .MuiFormControl-root .MuiInputBase-root .MuiInputBase-input": {
            padding: 0.8
          }
        }}
      />
      <IconButton k="refresh-list" onClick={() => setListShouldReload(true)}>
        <DekoxIcon icon="reload" fontSize="large" />
      </IconButton>
    </Stack>
  );
};

export const Search = connect(undefined, ownActions)(SearchBase);
